import React, {useEffect, useState} from 'react'
import {gsap} from 'gsap'
import Pearl from '../Pearl/Pearl'

interface PearlCloudProps {
  cloudImgSrc?: string
  className?: string
  trigger: boolean
  ref?: React.Ref<HTMLDivElement>
}

const PearlCloud: React.FC<PearlCloudProps> = ({cloudImgSrc, className, trigger, ref}) => {
  const [tl, setTl] = useState<gsap.core.Timeline | null>(null)
  const [pearlTrigger, setPearlTrigger] = useState(false)

  useEffect(() => {
    if (trigger) {
      const callback = (value: boolean) => {
        setPearlTrigger(value)
      }

      callback(true)
      gsap.delayedCall(5, () => {
        callback(false)
      })
    }
  }, [tl, trigger])

  return (
    <div className={`cloud ${className}`} style={{maskImage: `url(${cloudImgSrc})`}} ref={ref}>
      <Pearl backgroundSize={'150% 150%'} pearlTrigger={pearlTrigger} setTl={setTl} />
    </div>
  )
}

export default PearlCloud

try{ PearlCloud.displayName ||= 'PearlCloud' } catch {}